import { useEffect, useState } from "react";

import { SESSION_STORAGE_HYDRATED_EVENT } from "./use-navigation";
import { isPayrollProcessLocked } from "../utils/customConfigSession";

/** Reactive FR-042 payroll lock flag from session customConfig. */
export function usePayrollProcessLocked() {
    const [locked, setLocked] = useState(isPayrollProcessLocked);

    useEffect(() => {
        const sync = () => setLocked(isPayrollProcessLocked());
        window.addEventListener(SESSION_STORAGE_HYDRATED_EVENT, sync);
        return () => window.removeEventListener(SESSION_STORAGE_HYDRATED_EVENT, sync);
    }, []);

    return locked;
}
